import { useRef, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function Services() {
  const scrollContainerRef = useRef(null);
  const reviewsGridRef = useRef(null);

  const scrollReviews = (direction) => {
    const grid = reviewsGridRef.current;
    if (grid) {
      const containerWidth = grid.offsetWidth;
      const scrollAmount = containerWidth / 3 + 15;
      grid.scrollBy({
        left: direction * scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  useEffect(() => {
    // FAQ accordion functionality
    const handleFaqClick = (e) => {
      const question = e.currentTarget;
      const item = question.closest('.faq-item');
      const isActive = item.classList.contains('active');
      
      // Close all items
      document.querySelectorAll('.faq-item').forEach(faq => {
        faq.classList.remove('active');
        const toggle = faq.querySelector('.faq-toggle');
        if (toggle) toggle.textContent = '+';
      });
      
      // Open clicked item if it wasn't active
      if (!isActive) {
        item.classList.add('active');
        const toggle = item.querySelector('.faq-toggle');
        if (toggle) toggle.textContent = '−';
      }
    };

    const faqQuestions = document.querySelectorAll('.faq-question');
    faqQuestions.forEach(question => {
      question.addEventListener('click', handleFaqClick);
    });

    return () => {
      faqQuestions.forEach(question => {
        question.removeEventListener('click', handleFaqClick);
      });
    };
  }, []);

  return (
    <>
      <Header />
      
      <section className="services-page-section">
        <div className="container">
          <h1 className="services-page-title">
            <span className="services-title-line-1">WHAT'S</span>
            <br/>
            <span className="services-title-line-2">AVAILABLE?</span>
          </h1>
        </div>

        <div className="services-scroll-section">
          <div className="services-scroll-container" ref={scrollContainerRef}>
            <div className="service-image-card">
              <img src="/assets/services-first.jpeg" alt="Service 1" />
            </div>
            <div className="service-image-card">
              <img src="/assets/services-second.jpeg" alt="Service 2" />
            </div>
            <div className="service-image-card">
              <img src="/assets/services-third.jpeg" alt="Service 3" />
            </div>
            <div className="service-image-card">
              <img src="/assets/services-first.jpeg" alt="Service 1" />
            </div>
            <div className="service-image-card">
              <img src="/assets/services-second.jpeg" alt="Service 2" />
            </div>
            <div className="service-image-card">
              <img src="/assets/services-third.jpeg" alt="Service 3" />
            </div>
          </div>
        </div>
      </section>

      <section className="choose-services-section">
        <div className="container">
          <div className="choose-services-container">
            <div className="choose-services-left">
              <h2 className="choose-services-title">CHOOSE SERVICES</h2>
              <p className="choose-services-description">
                As a dedicated UI/UX designer and developer, I specialize in creating visually stunning and user-friendly digital experiences. My passion lies in crafting seamless interfaces that blend innovative design with intuitive functionality.
              </p>
              <a href="/contact" className="choose-services-cta">
                Contact Now <span>→</span>
              </a>
            </div>

            <div className="choose-services-list">
              <div className="choose-service-item">
                <div className="choose-service-number">[01]</div>
                <div className="choose-service-left-content">
                  <h3 className="choose-service-name">UX Design and Prototyping</h3>
                </div>
                <div className="choose-service-details">
                  <div className="choose-service-tags">User Research • Wireframing • Interactive Prototypes</div>
                  <p className="choose-service-description">
                    Creating intuitive user experiences through research-driven design, wireframing, and interactive prototypes that validate concepts before development.
                  </p>
                </div>
              </div>

              <div className="choose-service-item">
                <div className="choose-service-number">[02]</div>
                <div className="choose-service-left-content">
                  <h3 className="choose-service-name">UI Design and Branding</h3>
                </div>
                <div className="choose-service-details">
                  <div className="choose-service-tags">Visual Identity • Interface Design • Brand Guidelines</div>
                  <p className="choose-service-description">
                    Crafting beautiful, cohesive visual identities and user interfaces that reflect brand values and create memorable digital experiences.
                  </p>
                </div>
              </div>

              <div className="choose-service-item">
                <div className="choose-service-number">[03]</div>
                <div className="choose-service-left-content">
                  <h3 className="choose-service-name">Research and Strategy</h3>
                </div>
                <div className="choose-service-details">
                  <div className="choose-service-tags">User Testing • Analytics • Product Strategy</div>
                  <p className="choose-service-description">
                    Data-driven insights through user research, competitive analysis, and strategic planning to inform design decisions and drive business goals.
                  </p>
                </div>
              </div>

              <div className="choose-service-item">
                <div className="choose-service-number">[04]</div>
                <div className="choose-service-left-content">
                  <h3 className="choose-service-name">Development</h3>
                </div>
                <div className="choose-service-details">
                  <div className="choose-service-tags">Frontend • Responsive Design • Performance Optimization</div>
                  <p className="choose-service-description">
                    Transforming designs into high-performance, responsive web applications with clean code, modern frameworks, and seamless user interactions.
                  </p>
                </div>
              </div>

              <div className="choose-service-item">
                <div className="choose-service-number">[05]</div>
                <div className="choose-service-left-content">
                  <h3 className="choose-service-name">Video Editing</h3>
                </div>
                <div className="choose-service-details">
                  <div className="choose-service-tags">Motion Graphics • Color Grading • Post Production</div>
                  <p className="choose-service-description">
                    Professional video editing services bringing your visual stories to life with creative transitions, effects, and polished post-production quality.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="uiux-development-section">
        <div className="container">
          <div className="choose-services-container">
            <div className="choose-services-left">
              <h2 className="choose-services-title" style={{fontSize: '80px', lineHeight: '75px'}}>UI/UX DESIGN</h2>
              <p className="choose-services-description">
                Creating intuitive user experiences through research-driven design, wireframing, and interactive prototypes that validate concepts before development.
              </p>
              <a href="/contact" className="choose-services-cta">
                Contact Now <span>→</span>
              </a>
            </div>

            <div className="choose-services-list">
              <div className="choose-service-item">
                <div className="choose-service-number">[01]</div>
                <div className="choose-service-left-content">
                  <h3 className="choose-service-name">User Interface design</h3>
                </div>
                <div className="choose-service-details">
                  <div className="choose-service-tags">Visual Design • Component Libraries • Design Systems</div>
                  <p className="choose-service-description">
                    Crafting beautiful, intuitive interfaces that enhance user engagement and create memorable digital experiences.
                  </p>
                </div>
              </div>

              <div className="choose-service-item">
                <div className="choose-service-number">[02]</div>
                <div className="choose-service-left-content">
                  <h3 className="choose-service-name">Prototyping</h3>
                </div>
                <div className="choose-service-details">
                  <div className="choose-service-tags">Interactive Mockups • User Testing • Validation</div>
                  <p className="choose-service-description">
                    Building interactive prototypes to validate design concepts and gather user feedback before development.
                  </p>
                </div>
              </div>

              <div className="choose-service-item">
                <div className="choose-service-number">[03]</div>
                <div className="choose-service-left-content">
                  <h3 className="choose-service-name">UX design and usability</h3>
                </div>
                <div className="choose-service-details">
                  <div className="choose-service-tags">User Research • Usability Testing • Information Architecture</div>
                  <p className="choose-service-description">
                    Ensuring seamless user experiences through research-driven design and comprehensive usability testing.
                  </p>
                </div>
              </div>

              <div className="choose-service-item">
                <div className="choose-service-number">[04]</div>
                <div className="choose-service-left-content">
                  <h3 className="choose-service-name">Design system</h3>
                </div>
                <div className="choose-service-details">
                  <div className="choose-service-tags">Component Libraries • Style Guides • Documentation</div>
                  <p className="choose-service-description">
                    Creating comprehensive design systems that ensure consistency and scalability across products.
                  </p>
                </div>
              </div>

              <div className="choose-service-item">
                <div className="choose-service-number">[05]</div>
                <div className="choose-service-left-content">
                  <h3 className="choose-service-name">User flows and wireframes</h3>
                </div>
                <div className="choose-service-details">
                  <div className="choose-service-tags">Journey Mapping • Low-Fidelity Designs • Flow Diagrams</div>
                  <p className="choose-service-description">
                    Mapping user journeys and creating wireframes to establish clear navigation and interaction patterns.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="development-section">
        <div className="container">
          <div className="choose-services-container">
            <div className="choose-services-left">
              <h2 className="choose-services-title" style={{fontSize: '70px', lineHeight: '65px'}}>DEVELOPMENT</h2>
              <p className="choose-services-description">
                Transforming designs into high-performance, responsive web applications with clean code, modern frameworks, and seamless user interactions.
              </p>
              <a href="/contact" className="choose-services-cta">
                Contact Now <span>→</span>
              </a>
            </div>

            <div className="choose-services-list">
              <div className="choose-service-item">
                <div className="choose-service-number">[01]</div>
                <div className="choose-service-left-content">
                  <h3 className="choose-service-name">Web App Development</h3>
                </div>
                <div className="choose-service-details">
                  <div className="choose-service-tags">React • Modern Frameworks • Responsive Design</div>
                  <p className="choose-service-description">
                    Building scalable, high-performance web applications with modern technologies and best practices.
                  </p>
                </div>
              </div>

              <div className="choose-service-item">
                <div className="choose-service-number">[02]</div>
                <div className="choose-service-left-content">
                  <h3 className="choose-service-name">Animation and Creative Buttons</h3>
                </div>
                <div className="choose-service-details">
                  <div className="choose-service-tags">CSS Animations • Micro-interactions • Interactive Elements</div>
                  <p className="choose-service-description">
                    Creating engaging animations and interactive elements that enhance user experience and delight users.
                  </p>
                </div>
              </div>

              <div className="choose-service-item">
                <div className="choose-service-number">[03]</div>
                <div className="choose-service-left-content">
                  <h3 className="choose-service-name">
                    Motion Design <span style={{fontSize: '14px', fontWeight: '400', color: 'rgb(102, 102, 102)', marginLeft: '10px'}}>Starting Soon</span>
                  </h3>
                </div>
                <div className="choose-service-details">
                  <div className="choose-service-tags">Motion Graphics • Transitions • Visual Effects</div>
                  <p className="choose-service-description">
                    Advanced motion design services to bring your digital products to life with smooth, professional animations.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="working-process-section">
        <div className="container">
          <div className="working-process-container">
            <div className="working-process-left">
              <h2 className="working-process-title">WORKING PROCESS</h2>
            </div>

            <div className="working-process-list">
              <div className="process-item">
                <div className="process-step">[STEP-1]</div>
                <div className="process-content">
                  <h3 className="process-name">Send email</h3>
                  <p className="process-description">
                    Share your project idea and goals — a quick introduction to start the collaboration.
                  </p>
                </div>
              </div>

              <div className="process-item">
                <div className="process-step">[STEP-2]</div>
                <div className="process-content">
                  <h3 className="process-name">Meet online</h3>
                  <p className="process-description">
                    We discuss requirements, vision, and user needs to align the design direction perfectly.
                  </p>
                </div>
              </div>

              <div className="process-item">
                <div className="process-step">[STEP-3]</div>
                <div className="process-content">
                  <h3 className="process-name">Price estimation</h3>
                  <p className="process-description">
                    Clear scope, transparent pricing, and timeline planning before we begin the design process.
                  </p>
                </div>
              </div>

              <div className="process-item">
                <div className="process-step">[STEP-4]</div>
                <div className="process-content">
                  <h3 className="process-name">Work together</h3>
                  <p className="process-description">
                    Design, feedback, and refinement — turning ideas into a polished, user-focused final product.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="reviews-section">
        <div className="container">
          <div className="reviews-header">
            <h2 className="reviews-title">CLIENT<br/>REVIEWS</h2>
            <div className="reviews-nav">
              <button className="nav-arrow" onClick={() => scrollReviews(-1)}>←</button>
              <button className="nav-arrow" onClick={() => scrollReviews(1)}>→</button>
            </div>
          </div>

          <div className="reviews-grid" ref={reviewsGridRef}>
            <div className="review-card">
              <p className="review-text">"Working with Ansh on our app redesign was a game-changer. His creative vision and focus on user experience made a massive impact on our engagement metrics."</p>
              <div className="reviewer-info">
                <div className="reviewer-avatar">
                  <img src="https://i.pravatar.cc/150?img=33" alt="Rajesh Kumar" />
                </div>
                <div className="reviewer-details">
                  <h4>Rajesh Kumar</h4>
                </div>
              </div>
            </div>

            <div className="review-card">
              <p className="review-text">"Ansh brought a fresh perspective to our brand identity. His design expertise and understanding of our market made a huge difference in our product launch."</p>
              <div className="reviewer-info">
                <div className="reviewer-avatar">
                  <img src="https://i.pravatar.cc/150?img=27" alt="Sarah Mitchell" />
                </div>
                <div className="reviewer-details">
                  <h4>Sarah Mitchell</h4>
                </div>
              </div>
            </div>

            <div className="review-card">
              <p className="review-text">"Exceptional attention to detail and a deep understanding of modern design principles. Ansh delivered beyond our expectations and on time."</p>
              <div className="reviewer-info">
                <div className="reviewer-avatar">
                  <img src="https://i.pravatar.cc/150?img=12" alt="Priya Sharma" />
                </div>
                <div className="reviewer-details">
                  <h4>Priya Sharma</h4>
                </div>
              </div>
            </div>

            <div className="review-card">
              <p className="review-text">"His ability to translate complex requirements into intuitive designs is remarkable. The collaboration was smooth and the results speak for themselves."</p>
              <div className="reviewer-info">
                <div className="reviewer-avatar">
                  <img src="https://i.pravatar.cc/150?img=52" alt="Michael Chen" />
                </div>
                <div className="reviewer-details">
                  <h4>Michael Chen</h4>
                </div>
              </div>
            </div>

            <div className="review-card">
              <p className="review-text">"Ansh's strategic approach to UX design helped us reduce bounce rates by 40%. His insights into user behavior were invaluable to our success."</p>
              <div className="reviewer-info">
                <div className="reviewer-avatar">
                  <img src="https://i.pravatar.cc/150?img=47" alt="Amit Patel" />
                </div>
                <div className="reviewer-details">
                  <h4>Amit Patel</h4>
                </div>
              </div>
            </div>

            <div className="review-card">
              <p className="review-text">"Professional, creative, and incredibly responsive. Ansh transformed our vision into a beautiful, functional product that our users love."</p>
              <div className="reviewer-info">
                <div className="reviewer-avatar">
                  <img src="https://i.pravatar.cc/150?img=20" alt="Emma Thompson" />
                </div>
                <div className="reviewer-details">
                  <h4>Emma Thompson</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="faq-section">
        <div className="container">
          <div className="faq-container">
            <div className="faq-title">
              <h2>FAQ</h2>
            </div>
            <div className="faq-list">
              <div className="faq-item active">
                <div className="faq-question">
                  <span>Can you work with wireframes or our existing designs?</span>
                  <button className="faq-toggle">−</button>
                </div>
                <div className="faq-answer">
                  <p>Yes, absolutely. I can work with your provided wireframes, mockups, or existing designs to ensure consistency and alignment with your vision.</p>
                </div>
              </div>

              <div className="faq-item">
                <div className="faq-question">
                  <span>What happens after the design is ready & I approve it?</span>
                  <button className="faq-toggle">+</button>
                </div>
                <div className="faq-answer">
                  <p>Once approved, I'll prepare all design files, assets, and documentation for handoff. If development is needed, I can either implement it myself or provide detailed specifications for your development team.</p>
                </div>
              </div>

              <div className="faq-item">
                <div className="faq-question">
                  <span>Do you charge for additional revisions?</span>
                  <button className="faq-toggle">+</button>
                </div>
                <div className="faq-answer">
                  <p>The initial project scope includes a set number of revision rounds. Additional revisions beyond the agreed scope may incur extra charges, which we'll discuss upfront.</p>
                </div>
              </div>

              <div className="faq-item">
                <div className="faq-question">
                  <span>What do I need to give you to get started?</span>
                  <button className="faq-toggle">+</button>
                </div>
                <div className="faq-answer">
                  <p>To get started, I'll need your project brief, target audience information, brand guidelines (if any), reference designs you like, and any existing assets or content you want to include.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default Services;
